import { createListPage } from 'pages/common/ListPage';
import { createTable } from 'pages/common/ListTable';
import { createForm } from 'pages/common/Form';

import { selectors, actions } from 'domain/smcTag';
import { filterParams } from 'filters/smcTag';

import { tableParams, columns } from 'fields/smcTag';

const { list: items, onInlineEdit: edit, selected: selectedItems, loading, pagination } = selectors;
const { selectAction, inlineEditAction: onEdit, createItemAction, updateItemAction } = actions;

const Table = createTable({
  tableName: 'smcTagList',
  tableParams,
  updateItemAction,
  allowEdit: () => true,
  connections: {
    items,
    toggleRowCheck: selectAction,
    toggleAllSelected: selectAction,
    selectedItems,
    edit,
    onEdit,
    loading,
    pagination,
  },
});

export const Form = createForm({
  form: 'addSmcTag',
  action: createItemAction,
  formFields: columns.select('smcTag', 'fullName', 'defaultCarField', 'lowCarValue', 'carValue', 'highCarValue'),
});

export default createListPage({
  name: 'SmcTag',
  pagination,
  filterParams,
  Table,
  Form,
});
